import { type FlagsManager } from '@databases/flags-types';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { DefaultFlagGroup } from './DefaultFlagGroup.tsx';

export function mountDefaultFlagGroup(flagsManagerFactory: () => FlagsManager): void {
  const fragment = document.createDocumentFragment();
  const el = document.createElement('div');
  const flagsManager = flagsManagerFactory();

  fragment.appendChild(el);

  createRoot(el).render(
    <DefaultFlagGroup
      flags={flagsManager.flags}
      handleFlagDismiss={(flagId: number | string) =>
        flagsManager.handleFlagDismiss(flagId)
      }
    />
  );

  document.body.append(fragment);
}
